export default function AboutImageBreak() {
  return (
    <section className="relative">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-8 img-zoom overflow-hidden aspect-[16/9]">
            <img
              src="https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1800&q=85"
              alt="Heritage palace at dusk"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="col-span-12 md:col-span-4 flex flex-col gap-4">
            <div className="img-zoom overflow-hidden aspect-square">
              <img
                src="https://indiorajourneys.com/images/India6.jpg"
                alt="Craft detail"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="img-zoom overflow-hidden aspect-[4/5] md:flex-1">
              <img
                src="https://indiorajourneys.com/images/Bhutan2.jpg"
                alt="Monastery"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
